import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useHandleActionItem } from "../../../hooks/useHandleActionItem.js";
import InputText from "../../../components/forms/InputText.jsx";
import InputDate from "../../../components/forms/InputDate.jsx";
import { apiUrl } from "../../../config/config.js";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

const reverseTranslateKeys = (data) => {
	const reverseMap = {
		Correo: "email",
		Nombre: "name",
		Teléfono: "phone",
		Rol: "role",
		ID: "id",
		Admin: "admin",
		Administrador: "admin",
		Creado: "createdAt",
	};

	const normalized = {};
	for (const key in data) {
		const normalizedKey = reverseMap[key] || key;
		normalized[normalizedKey] = data[key];
	}
	return normalized;
};

function UserDetails() {
	const location = useLocation();
	const navigate = useNavigate();
	const locationType = location.state?.type || "";
	const data = useMemo(() => location.state?.data || [], [location.state?.data]);
	console.log("DETILS DATA:", data);

	const [user, setUser] = useState({});
	const { handleDelete, handleSubmit } = useHandleActionItem();

	useEffect(() => {
		if (locationType === "edit" && data) {
			setUser(reverseTranslateKeys(data));
		}
	}, [locationType, data]);

	const validateForm = () => {
		if (!user.name || !user.email || !user.role) {
			Toast.fire({
				icon: "error",
				title: "Los campos obligatorios no pueden estar vacíos",
				background: "#1e2836",
			});
			return false;
		}
		return true;
	};

	const handleInputChange = (field, value) => {
		setUser((prev) => ({ ...prev, [field]: value }));
	};

	const handleSubmitForm = async (event) => {
		event.preventDefault();
		if (!validateForm()) return;

		try {
			if (locationType === "add") {
				const response = await fetch(apiUrl + "/register", {
					method: "POST",
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(user),
				});
				const responseData = await response.json();
				if (responseData.ok) {
					Toast.fire({ icon: "success", title: responseData.message, background: "#1e2836", color: "#fff" });
					window.history.back();
					return;
				} else {
					Toast.fire({ icon: "error", title: responseData.message, background: "#1e2836", color: "#fff" });
				}
			} else {
				await handleSubmit("update", "users", user);
			}
			navigate("/users");
		} catch (error) {
			console.log("ERROR", error);
		}
	};

	const handleDeleteForm = async (event) => {
		event.preventDefault();
		await handleDelete(user.id, "users", true);
	};

	return (
		<div>
			<form onSubmit={handleSubmitForm}>
				<h1 className="text-center">{locationType === "add" ? "Agregar Usuario" : "Actualizar Usuario"}</h1>

				<InputText label="ID" value={user.id || ""} setValue={(v) => handleInputChange("id", v)} disabled={true} />
				<InputText label="Nombre" value={user.name || ""} setValue={(v) => handleInputChange("name", v)} />
				<InputText label="Teléfono" value={user.phone || ""} setValue={(v) => handleInputChange("phone", v)} />
				<InputText
					label="Correo"
					value={user.email || ""}
					setValue={(v) => handleInputChange("email", v)}
					disabled={locationType === "edit"}
				/>

				<InputText label="Rol" value={user.role || ""} setValue={(v) => handleInputChange("role", v)} />
				<InputDate label="Creación" value={user.createdAt || ""} setValue={(v) => handleInputChange("createdAt", v)} disabled={true} />

				<div className="form-check form-switch mb-3">
					<input
						className="form-check-input"
						type="checkbox"
						checked={user.admin === 1}
						onChange={(e) => handleInputChange("admin", e.target.checked ? 1 : 0)}
					/>
					<label className="form-check-label">Administrador</label>
				</div>

				<hr />
				<div className="mb-3 d-flex justify-content-around ">
					<button type="submit" className="btn btn-outline-theme btn-lg">
						{locationType === "add" ? "Agregar" : "Actualizar"}
					</button>
					<button onClick={() => navigate("/users")} className="btn btn-outline-theme btn-lg">
						Atrás
					</button>
					{locationType === "edit" && (
						<button onClick={handleDeleteForm} className="btn btn-outline-danger btn-lg">
							Eliminar
						</button>
					)}
				</div>
			</form>
		</div>
	);
}

export default UserDetails;
